import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tir-pm-global-status" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = ["src"]

import { TaskParameterModel } from "@/components/task-parameter/models";
import { ref, computed, onMounted, watch, PropType } from "vue";
import { Cog6ToothIcon, UserGroupIcon } from "tir-style-system/icons/outline";
// // Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmGlobalStatus',
  props: {
  value: { type: Object as PropType<TaskParameterModel> },
},
  setup(__props) {

const props = __props;

// Импорты из Vue 3 Composition API


// // Определение эмиттеров событий компонента
// const emits = defineEmits<{
//   clickLogout: [], // Событие при клике на кнопку "Выход"
//   "update:message": [string]; // Событие обновления сообщения
// }>();

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", _hoisted_2, [
        (__props.value?.ImgUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.value?.ImgUrl,
              alt: ""
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createBlock(_unref(Cog6ToothIcon), { key: 1 }))
      ]),
      _createElementVNode("div", {
        class: "name",
        style: _normalizeStyle({ color: __props.value?.Color, textTransform: 'uppercase' })
      }, _toDisplayString(__props.value?.Name), 5)
    ])
  ]))
}
}

})